<template>
  <input
    :id="id"
    :type="type"
    class="input-item"
    :class="[variant, size, isEmpty]"
    :placeholder="placeholder"
    :value="modelValue"
    :tabindex="tabindex"
    :maxlength="maxlength"
    formnovalidate
    :disabled="disabled"
    @input="updateValue"
    @change="sendChangeEvent($event)"
    @focus="sendFocusEvent($event)"
    @blur="sendBlurEvent($event)"
    @click="sendClickEvent($event)"
    @mousedown="sendMousedownEvent($event)"
    @mouseover="sendMouseoverEvent($event)"
    @mouseout="sendMouseoutEvent($event)"
    @keydown="sendKeydownEvent($event)"
    @keyup="sendKeyupEvent($event)"
  />
</template>

<script>
import {
  sendInputEvent,
  sendFocusEvent,
  sendChangeEvent,
  sendBlurEvent,
  sendClickEvent,
  sendMousedownEvent,
  sendMouseoverEvent,
  sendMouseoutEvent,
  sendKeydownEvent,
  sendKeyupEvent,
} from "@/utils/FormEvent";
export default {
  name: "InputItem",
  props: {
    modelValue: { type: String, default: "" },
    variant: { type: String, default: "" },
    size: { type: String, default: "" },
    id: { type: String, default: "" },
    name: { type: String, default: "", require: true },
    type: { type: String, default: "text" },
    maxlength: { type: Number, default: 500 },
    placeholder: { type: String, default: "" },
    tabindex: { type: String, default: "" },
    emptyColor: { type: String, default: "" },
    trackingName: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "input", "change"],
  setup() {
    return {
      sendInputEvent,
      sendFocusEvent,
      sendChangeEvent,
      sendBlurEvent,
      sendClickEvent,
      sendMousedownEvent,
      sendMouseoverEvent,
      sendMouseoutEvent,
      sendKeydownEvent,
      sendKeyupEvent,
    };
  },
  data() {
    return {
      inputValue: this.modelValue,
    };
  },
  computed: {
    isEmpty() {
      return this.emptyColor && this.modelValue.length < 1 ? "-empty" : "";
    },
  },
  methods: {
    updateValue(e) {
      this.sendInputEvent(e);
      if (e.target.value.length > this.maxlength) {
        e.target.value = e.target.value.slice(0, this.maxlength);
      }
      this.$emit("input", e.target.value);
      this.$emit("change", e.target.value);
      this.$emit("update:modelValue", e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.input-item {
  border: 1px solid $secondary;
  padding: 14px 10px;
  line-height: 20px;
  width: 100%;
  font-size: 16px;
  @include mq-up(md) {
    padding: 10px;
  }
  &.-empty {
    background-color: $info;
  }
  &.-lg {
    max-width: 600px;
  }
  &.-md {
    max-width: 350px;
  }
  &.-sm {
    max-width: 180px;
    @include mq-up(md) {
      max-width: 200px;
    }
  }
  &.-xs {
    max-width: 100px;
    @include mq-up(md) {
      max-width: 100px;
    }
  }
  &.-radio {
    max-width: 40px;
    padding: 4px;
    margin: 0 2px;
    @include mq-up(md) {
      max-width: 40px;
    }
  }
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield;
}
</style>
